// Subscriber pay page — offline payment instructions. ChitDesk does NOT process
// member chit payments online; members pay their operator directly (cash / UPI /
// cheque) and the operator records it.

import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function SubPay(): ReactElement {
  const { t } = useTranslation();

  const methods: Array<{ title: string; body: string }> = [
    {
      title: t('sub.pay.m_cash', 'Cash'),
      body: t('sub.pay.m_cash_b', 'Hand the amount to your operator or collector. Ask for a receipt.'),
    },
    {
      title: t('sub.pay.m_upi', 'UPI'),
      body: t('sub.pay.m_upi_b', 'Send the amount to your operator’s UPI number, then share a screenshot with them so they can record it.'),
    },
    {
      title: t('sub.pay.m_cheque', 'Cheque'),
      body: t('sub.pay.m_cheque_b', 'Give a cheque to your operator for the amount due.'),
    },
  ];

  return (
    <>
      <Link to="/sub" className="btn ghost sm" style={{ alignSelf: 'flex-start' }}>
        ← {t('actions.back', 'Back')}
      </Link>
      <div className="h-title" style={{ fontSize: 20 }}>{t('sub.pay.title', 'How to pay')}</div>

      <div style={{ fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.5 }}>
        {t('sub.pay.offline_intro', 'Pay your chit operator directly using any of these methods. They will record your payment and it will appear in your history.')}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {methods.map((mth) => (
          <div key={mth.title} className="card" style={{ padding: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink)', marginBottom: 3 }}>{mth.title}</div>
            <div style={{ fontSize: 12.5, color: 'var(--ink-3)', lineHeight: 1.5 }}>{mth.body}</div>
          </div>
        ))}
      </div>

      <div style={{ background: 'var(--info-soft)', color: 'var(--info)', borderRadius: 'var(--radius-lg)', padding: 12, fontSize: 12, lineHeight: 1.5 }}>
        {t('sub.pay.offline_note', 'Keep your receipt or UPI screenshot until your payment shows as paid in your history.')}
      </div>
    </>
  );
}
